import { render, staticRenderFns } from "./EditMenuItem.vue?vue&type=template&id=13ea402a"
import script from "./EditMenuItem.vue?vue&type=script&lang=ts"
export * from "./EditMenuItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports